import { useContext } from 'react';
import { View } from '@shared/components/View';
import { MBTextOverline } from '@shared/components/typography';
import { ColorThemeContext, grid } from '@shared/styles';
import { i18n } from '@shared/util/i18n';

export function MBCardQuantityHeader() {
  const colors = useContext(ColorThemeContext);
  return (
    <View row paddingHorizontal={2} paddingBottom={1}>
      <View style={{ width: grid(5) }}>
        <MBTextOverline align="center" color={colors.input.label}>
          {i18n('card.blocks.cardsInput.quantity.header.quantity')?.toUpperCase() ?? ''}
        </MBTextOverline>
      </View>
      <View paddingLeft={2}>
        <MBTextOverline color={colors.input.label}>
          {i18n('card.blocks.cardsInput.quantity.header.name')?.toUpperCase() ?? ''}
        </MBTextOverline>
      </View>
    </View>
  );
}
